const RELOADED_AT_KEY = 'staleChunkReloadedAt';
// A chunk still missing after a reload is really missing: leave it to the
// nearest ErrorBoundary rather than reloading again
const RELOAD_GUARD_MS = 60 * 1000;

const readReloadedAt = (): number => {
  try {
    return Number(sessionStorage.getItem(RELOADED_AT_KEY)) || 0;
  } catch {
    return 0;
  }
};

// Vite's vite:preloadError fires when a lazily loaded chunk fails to load,
// usually as a tab opened before a deploy asks for one the new build no
// longer serves. Reloading picks up the new build. The error is still thrown,
// so the nearest ErrorBoundary shows "A new version..." until the reload.
export const onPreloadError = ({ now }: { now: number }): boolean => {
  if (now - readReloadedAt() < RELOAD_GUARD_MS) {
    return false;
  }
  try {
    sessionStorage.setItem(RELOADED_AT_KEY, String(now));
  } catch {
    // storage unavailable: reload anyway
  }
  window.location.reload();
  return true;
};

const reloadOnStaleChunk = () => {
  window.addEventListener('vite:preloadError', () => {
    onPreloadError({ now: Date.now() });
  });
};

export default reloadOnStaleChunk;
